(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tw-prod-info-table"] && !Shopify.designMode) return;
  try {
    
class Tooltip {
  constructor(triggerElement) {
    this.triggerElement = triggerElement;
    this.tooltip = triggerElement.querySelector('.tool-tip-holder');
    this.closeButton = this.tooltip.querySelector('.tool-tip-close');

    // Event listeners for hover and close actions
    this.triggerElement.addEventListener('mouseover', this.showTooltip.bind(this));
    this.triggerElement.addEventListener('mouseout', this.hideTooltip.bind(this));
    this.closeButton.addEventListener('click', this.hideTooltip.bind(this)); 
  }

  showTooltip() {
    this.tooltip.classList.add('tool-tip-holder--visible');
    this.triggerElement.classList.add('visible');
  }

  hideTooltip() {
    this.tooltip.classList.remove('tool-tip-holder--visible');
    this.triggerElement.classList.remove('visible');
  }
}

// Initialize tooltips after the page loads
window.addEventListener('DOMContentLoaded', () => {
  const tooltips = document.querySelectorAll('.tooltip-trigger');
  tooltips.forEach(trigger => {
    new Tooltip(trigger);
  });
});


  } catch(e) { console.error(e); }
})();
})();
